
export const UserRole = Object.freeze({
  OWNER: 'owner',
  ACCOUNTANT: 'accountant',
  SECRETARY: 'secretary',
});

export const TransactionType = Object.freeze({
  IN: 'in',
  OUT: 'out',
  EXTERNAL_OUT: 'external-out',
});
